enum FileSizeUnit {
  KILOBYTE = "KB",
  MEGABYTE = "MB",
}

const KILOBYTE = 1024;
export const MEGABYTE = KILOBYTE ** 2;

const getDisplayValueForFileSizeInUnits = (fileSize: number, unit: string) => {
  if (fileSize < 1) {
    return `${fileSize.toFixed(2)} ${unit}`;
  }

  if (fileSize < 10) {
    return `${fileSize.toFixed(1)} ${unit}`;
  }

  return `${Math.round(fileSize)} ${unit}`;
};

export const getDisplayValueForFileSize = (fileSize: number) => {
  if (fileSize < MEGABYTE) {
    return getDisplayValueForFileSizeInUnits(
      fileSize / KILOBYTE,
      FileSizeUnit.KILOBYTE,
    );
  }

  return getDisplayValueForFileSizeInUnits(
    fileSize / MEGABYTE,
    FileSizeUnit.MEGABYTE,
  );
};
